function AllCreditSelect() {
    $('#divChildBoxes :checkbox').prop('checked', $('#spanAll :checkbox').prop('checked') ? false : '');
    CheckAllSelections();
}

function ExcellentCreditSelect() {
    $('#spanExcellentChild :checkbox').prop('checked', $('#chkExcellent').prop('checked'));
    $('#spanAll :checkbox').prop('checked', $('#chkExcellent').prop('checked') ? false : true);
    CheckAllSelections();
}

function ExcellentChildrenSelect() {
    $("#chkExcellent").prop('checked', $('#spanExcellentChild input:checked').length == 2 ? true : false);
    CheckAllSelections();
}

function VeryGoodCreditSelect() {
    $('#spanVeryGoodChild :checkbox').prop('checked', $('#chkVeryGood').prop('checked'));
    CheckAllSelections();
}

function VeryGoodChildrenSelect() {
    $("#chkVeryGood").prop('checked', $('#spanVeryGoodChild input:checked').length == 2 ? true : false);
    CheckAllSelections();
}

function GoodCreditSelect() {
    $('#spanGoodChild :checkbox').prop('checked', $('#chkGood').prop('checked'));
    CheckAllSelections();
}

function GoodChildrenSelect() {
    $("#chkGood").prop('checked', $('#spanGoodChild input:checked').length == 2 ? true : false);
    CheckAllSelections();
}

function InstitutionSelect() {
    $('#spanAll :checkbox').prop('checked', $('#chkInstitution').prop('checked') ? false : true);
    CheckAllSelections();
}

function UnknownSelect() {
    $('#spanAll :checkbox').prop('checked', $('#chkUnknown').prop('checked') ? false : true);
    CheckAllSelections();
}

function CheckAllSelections() {
    var children = $('#divChildBoxes input:checked').length;
    $('#spanAll :checkbox').prop('checked', children == 0 ? true : children == 11 ? true : false);
    $('#divChildBoxes input:checked').prop('checked', $('#spanAll :checkbox').prop('checked') ? false : true);
}
